import { render, staticRenderFns } from "./MyColumn.vue?vue&type=template&id=51c729b6&"
import script from "./MyColumn.vue?vue&type=script&lang=js&"
export * from "./MyColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports